import React, { FC } from 'react';
import { TemplateInsightGroupBy } from 'api/template-insight';
import { Filter } from 'components/molecules/filters/types';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { useTranslate } from 'hooks/use-translation';
import { useTemplateInsightQuery } from 'queries/template-insight';
import { AutoHeightTable } from '../auto-heigh-table';
import { Wrapper } from '../components';
import { DefaultEmptyTable } from '../empty-state';
import { useTimeTrackedTemplateTable } from './utils';

export const ByTemplate: FC<{
  range: DateRange;
  filter: Filter;
}> = ({ range, filter }) => {
  const translate = useTranslate();
  const { data: templateInsight, isLoading } = useTemplateInsightQuery({
    groupBy: TemplateInsightGroupBy.ProjectTimeTracked,
    range,
    filter,
  });
  const { dataSource, tableColumn } = useTimeTrackedTemplateTable({
    templateInsight,
  });

  return (
    <Wrapper>
      <AutoHeightTable
        dataSource={dataSource}
        columns={tableColumn}
        titleLabel={translate(
          'reports.template_insight.time_tracked_vs_planned.project.table.title',
        )}
        isLoading={isLoading}
        renderEmpty={() =>
          DefaultEmptyTable({ noDataKey: 'report.table.empty.time.template' })
        }
      />
    </Wrapper>
  );
};
